import { initialState } from './selectors';
import {
  ADD_MARKET_SETTINGS,
} from './actions';

export default (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case ADD_MARKET_SETTINGS:
      return {
        ...state,
        ...payload.settings,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/market/reducer.js